import React, { Component } from 'react'
import lang from '../lang'
import './index.less'

export default class extends Component {
  render() {
    let { lang } = this.props
    const { availShow } = this.props
    let userInfo = this.props.userInfo
    let nationalList = [
      {
        name: 'India',
        img: 'https://img.chatie.live/app/country/India.png',
        id: 43
      },
      {
        name: 'Iraq',
        img: 'https://img.chatie.live/app/country/Iraq.png',
        id: 32
      },
      {
        name: 'Pakistan',
        img: 'https://img.chatie.live/app/country/Pakistan.png',
        id: 10
      },
      {
        name: 'KSA',
        img: 'https://img.chatie.live/app/country/SaudiArabia.png',
        id: 17
      },
      {
        name: 'Turkey',
        img: 'https://img.chatie.live/app/country/Turkey.png',
        id: 39
      },
      {
        name: 'Algeria',
        img: 'https://img.chatie.live/app/country/Algeria.png',
        id: 40
      },
      {
        name: 'Oman',
        img: 'https://img.chatie.live/app/country/Oman.png',
        id: 9
      },
      {
        name: 'Yemen',
        img: 'https://img.chatie.live/app/country/Yemen.png',
        id: 15
      },
      {
        name: 'Kurdistan',
        img: 'https://img.chatie.live/app/country/Kurdistan.png',
        id: 46
      },
      {
        name: 'Bahrain',
        img: 'https://img.chatie.live/app/country/Bahrain.png',
        id: 3
      },
      {
        name: 'Egypt',
        img: 'https://img.chatie.live/app/country/Egypt.png',
        id: 42
      },
      {
        name: 'Jordan',
        img: 'https://img.chatie.live/app/country/Jordan.png',
        id: 30
      },
      {
        name: 'Kuwait',
        img: 'https://img.chatie.live/app/country/Kuwait.png',
        id: 25
      },
      {
        name: 'Lebanon',
        img: 'https://img.chatie.live/app/country/Lebanon.png',
        id: 28
      },
      {
        name: 'Morocco',
        img: 'https://img.chatie.live/app/country/Morocco.png',
        id: 34
      },
      {
        name: 'Palestine',
        img: 'https://img.chatie.live/app/country/Palestine.png',
        id: 27
      },
      {
        name: 'Qatar',
        img: 'https://img.chatie.live/app/country/Qatar.png',
        id: 16
      },
      {
        name: 'Syria',
        img: 'https://img.chatie.live/app/country/Syria.png',
        id: 33
      },
      {
        name: 'Tunisia',
        img: 'https://img.chatie.live/app/country/Tunisia.png',
        id: 18
      },
      {
        name: 'Uae',
        img: 'https://img.chatie.live/app/country/UnitedArabEmirates.png',
        id: 37
      }
    ]
    // 判断是否在国家里面
    let inList = false
    nationalList.map((item) => {
      if (item.id === userInfo.countryId) {
        inList = true
      }
    })
    console.log(availShow)
    return (
      <div style={{ marginTop: availShow }} className="container-avail">
        <div className="mark"></div>
        <div className={`reminder-wrap ${availShow == '0' ? 'active' : ''}`} onClick={() => this.props.changeAvail()}>
          <div className="title">{lang.ac}</div>
          <div className="desc">
            <div className="tips" style={{ display: inList ? 'none' : 'block' }}>
              Your country is not within the scope of the competition, please change your account to another country or
              suggest to the administrator to add your country
            </div>
            {nationalList.map((item, index) => {
              return (
                <div className="gj" key={index}>
                  <div className="guojia">
                    <img src={item.img} alt="" />
                  </div>
                  <div className="name">{item.name}</div>
                </div>
              )
            })}
          </div>
          {/* <div className="close"></div> */}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/national/Available/index.js